import React from 'react';
import { TableCell, TableSortLabel, makeStyles, createStyles } from '@material-ui/core';
import { Order } from 'utils/sort';

interface Props {
    orderBy: string;
    property: string;
    order: Order;
    label: string;
    onRequestSort(property: string): void;
}

const useStyles = makeStyles(() =>
    createStyles({
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
        },
    })
);

const TableSortCell = ({ orderBy, property, order, label, onRequestSort }: Props) => {
    const classes = useStyles();

    const createSortHandler = (property: string) => () => {
        onRequestSort(property);
    };

    return (
        <TableCell sortDirection={orderBy === property ? order : false}>
            <TableSortLabel
                active={orderBy === property}
                direction={orderBy === property ? order : 'asc'}
                onClick={createSortHandler(property)}
            >
                {label}
                {orderBy === property ? (
                    <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                ) : null}
            </TableSortLabel>
        </TableCell>
    );
};

export default TableSortCell;
